document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 767) return;

  const blocks = document.querySelectorAll(".bls__footer_block");

  blocks.forEach(block => {
    const title = block.querySelector(".bls__footer_block-title");
    const content = block.querySelector(".bls__footer_block-content");

    if (!title || !content) return;

    // default close
    content.style.display = "none";

    title.addEventListener("click", function () {

      const isOpen = content.style.display === "block";

      // close all
      document.querySelectorAll(".bls__footer_block-content").forEach(c => {
        c.style.display = "none";
      });

      // open current if it was closed
      if (!isOpen) {
        content.style.display = "block";
      }

    });
  });

});
